<script setup lang="ts">
import RecapDefinition from './recaps/RecapDefinition.vue'
import BaseModal from './wrappers/BaseModal.vue'
import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
const props = defineProps<{
  recapId: any
  recapType: 'task' | 'store'
  modelValue: boolean
}>()
const emit = defineEmits<{
  (e: 'continueToLegal', overrideRule: boolean): void
  (e: 'update:modelValue'): void
}>()
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
</script>
<template>
  <BaseModal v-model="value">
    <template #title> {{ label('recapPreview') }} </template>
    <template #content>
      <RecapDefinition
        :recap-id="recapId"
        :recap-type="recapType"
        :task-or-store-id="'0'"
        :existing-recap-response="undefined"
        :testing-recap="true"
        :preview-recap="true"
      ></RecapDefinition>
    </template>
    <template #actions>
      <q-btn rounded flat :label="label('close')" v-close-popup />
    </template>
  </BaseModal>
</template>
